__turbopack_context__.v({
  "root": "template-module-scss-module__ejNzbG__root",
});
